module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b276889e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CenterHeader.vue
// module id = 467
// module chunks = 1